async function resolveResponse(res: any) {

  if (res.status === 204)
    return Promise.resolve();

  if (200 <= res.status && res.status <= 299)
    return await res.json();

  const text = await res.text();
  let error = text;

  try {
    const json = JSON.parse(text);

    if (json["detail"])
      error = json["detail"];
  } catch { }

  throw new Error(error);
}

export function getData(path: string, token: string) {
  return fetch(process.env.REACT_APP_API_ENDPOINT + path, {
    'method': 'GET',
    'headers': {
      'Content-Type': 'application/json',
      'X-Token': token,
    }
  })
    .then(resolveResponse);
}

export function deleteData(path: string, token: string) {
  return fetch(process.env.REACT_APP_API_ENDPOINT + path, {
    'method': 'DELETE',
    'headers': {
      'Content-Type': 'application/json',
      'X-Token': token,
    }
  })
    .then(resolveResponse);
}

export function putData(path: string, token: string, data: any = {}) {
  return fetch(process.env.REACT_APP_API_ENDPOINT + path, {
    'method': 'PUT',
    'headers': {
      'Content-Type': 'application/json',
      'X-Token': token,
    },
    'body': JSON.stringify(data)
  })
    .then(resolveResponse);
}

export function postData(path: string, token: string, data: any = {}) {
  return fetch(process.env.REACT_APP_API_ENDPOINT + path, {
    'method': 'POST',
    'headers': {
      'Content-Type': 'application/json',
      'X-Token': token,
    },
    'body': JSON.stringify(data)
  })
    .then(resolveResponse);
}
